import { appApi } from "../api";
import { License } from "@/@types/app/License";

export async function getAllLicenses() {
	const response = await appApi.get<License[]>("/license");
	return response.data || [];
}
